export default {
  //课中活动讨论
  showInfo: {
    detail:''
  },
  showList: '',
}



// WEBPACK FOOTER //
// ./src/store/kzActivity/show/states.js